export default {
    namespaced: true,
    state: {
        subcategories: [],
    },
    getters: {
        getAll(state) {
            return state.subcategories;
        },
    },
    mutations: {
        setAll(state, subcategories) {
            Object.assign(state, {
                subcategories,
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const subcategories = await context.dispatch('api/request', {
                service: 'subcategory',
                type: 'getAll',
            }, { root: true });

            if (subcategories) {
                context.commit('setAll', subcategories);
            }
        },
    },
};
